import 'bootstrap';

import '../static/polyfills/liga.js';

import 'styles/public';

import init from './client';

init();
